export enum ETogglerType {
  TOGGLE = 'toggle',
  CHECKBOX = 'checkbox'
}

export interface IListControlProps extends React.InputHTMLAttributes<HTMLInputElement> {
  children?: React.ReactNode;
  togglerType?: ETogglerType;
  onCheck: (isChecked: boolean) => void;
}

export interface IListControlStyledProps {
  $isChecked: boolean;
}
